import { render, staticRenderFns } from "./ChipUsuario.vue?vue&type=template&id=a2daf188&scoped=true"
import script from "./ChipUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipUsuario.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2daf188",
  null
  
)

export default component.exports